import { Component } from "react"
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { rules, Permission } from "../../../../abac.config";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AccessDenied from "../../../common/AccessDenied";
import ConfirmBox from '../../../common/ConfirmBox';
import masterDataService from "../../../services/MasterDataService";
import { createNotification } from "../../../helpers/Notification";
import { setLocalStorageMasterDataItems, getLocalStorageMasterDataItems, removeLocalStorageMasterDataItems } from "../../../project/Helper";
class GeneraContractorList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            generalContractorList: [],
            isShowConfirmBox: false,
            removeId: "",
            resDataLen: 0,
            pageChange: 1,
            limit: 10,
            count: 0,
            skip: 0,

        }
    }

    componentDidMount = () => {
        this.getGeneralContractPaginationConstants();
    }


    getGeneralContractPaginationConstants = () => {
        const { limit, skip } = this.state;
        let filters;
        const data = getLocalStorageMasterDataItems("generalContractPaginationConstants");
        console.log(data);

        if (data !== null && data !== undefined) {
            const { generalContractLimit, generalContractPageChange, generalContractSkip } = data;
            this.setState({
                pageChange: generalContractPageChange,
                limit: generalContractLimit,
                skip: generalContractSkip
            }, () => {
                filters = `?filter[skip]=${generalContractSkip}&filter[limit]=${generalContractLimit}`;
                this.getGeneralContractList(filters);
                removeLocalStorageMasterDataItems("generalContractPaginationConstants");
            });
        } else {
            filters = `?filter[skip]=${skip}&filter[limit]=${limit}`;
            this.getGeneralContractList(filters);
        }
    }
    getGeneralContractList = (filters) => {
        // code to get the data and set into the varible
        masterDataService.getGeneralContractorList(filters).then((response) => {
            this.setState({
                generalContractorList: response.data.data.data,
                count: response.data.data.count,
                resDataLen: response.data.data.data.length
            })
        }).catch((error) => {
            if (error.response && error.response.status === 401) {
                createNotification("error", "Your login session has expired!");
                localStorage.clear();
                this.props.history.push("/login");
            } else {
                createNotification("error", error.response?.data?.error?.message || "Error fetching data");
            }
        })
    }

    actionFormat = (cell, row, rowIndex, formatExtraData) => {
        return (
            <div>
                <td>
                    <ul className="list-inline mb-0">
                        <li className="list-inline-item" onClick={this.setLocalStorageItems}>
                            <Link to={`/generalContractorList/${row.id}`}>
                                <i className="uil uil-pen font-size-18"></i>
                            </Link>
                        </li>
                        <li className="list-inline-item">
                            <a href="javascript:void(0)" className="text-danger">
                                <i
                                    className="uil uil-trash-alt font-size-18"
                                    onClick={() => this.setState({ removeId: row.id, isShowConfirmBox: true })}
                                ></i>
                            </a>
                        </li>
                    </ul>
                </td>
            </div>
        );
    }

    setLocalStorageItems = () => {
        const { pageChange, skip, limit } = this.state;

        let data = {
            generalContractPageChange: pageChange,
            generalContractSkip: skip,
            generalContractLimit: limit
        }
        setLocalStorageMasterDataItems("generalContractPaginationConstants", data);
    }

    handleOnTableChange = (type, newState) => {
        const { generalContractorList } = this.state;

        if (type === "sort") {
            if (newState.sortOrder === "asc") {
                generalContractorList.sort((a, b) => a[newState.sortField].trim().localeCompare(b[newState.sortField].trim(), undefined, { numeric: true, sensitivity: 'base' }));
            } else {
                generalContractorList.sort((b, a) => a[newState.sortField].trim().localeCompare(b[newState.sortField].trim(), undefined, { numeric: true, sensitivity: 'base' }));
            }
            this.setState({ generalContractorList });
        }
    }

    handleConfirmModal = (isYes) => {
        if (isYes) {

            const { removeId, resDataLen, pageChange, skip, limit } = this.state;
            let filters;

            if (resDataLen === 1 && pageChange > 1) {
                let localskip = skip - limit;
                let localPage = pageChange - 1;
                this.setState({
                    skip: localskip,
                    pageChange: localPage
                }, () => {
                    filters = `?filter[skip]=${localskip}&filter[limit]=${limit}`;
                    this.deleteGeneralContractor(removeId, filters);
                });
            } else {
                filters = `?filter[skip]=${skip}&filter[limit]=${limit}`;
                this.deleteGeneralContractor(removeId, filters);
            }
        } else {
            this.setState({ isShowConfirmBox: false, removeId: '' });
        }
    }
    // delete logic for the item 
    deleteGeneralContractor = (removeId, filters) => {
        masterDataService.deleteGeneralContractorItem(removeId).then((res) => {
            createNotification("success", "General contractor deleted successfully.");
            this.setState({ isShowConfirmBox: false, removeId: '' });
            this.getGeneralContractList(filters);
        }).catch((error) => {
            console.log(error);

        })
    }

    render() {
        const { isShowConfirmBox, pageChange, limit, skip, count, generalContractorList } = this.state;
        const { loginUserData } = this.props;

        const columns = [
            { dataField: "name", text: "Name", sort: true },
            { dataField: "status", text: "Status", sort: true },
            { dataField: "", text: "Action", formatter: this.actionFormat }
        ];

        const sizePerPageOptions = [
            { text: '10', value: 10 },
            { text: '25', value: 25 },
            { text: '30', value: 30 },
            { text: '50', value: 50 },
            { text: '100', value: 100 },
        ];

        let that = this;
        const pagination = paginationFactory({
            page: pageChange,
            sizePerPage: limit,
            lastPageText: ">>",
            firstPageText: "<<",
            nextPageText: ">",
            prePageText: "<",
            totalSize: count,
            hideSizePerPage: false,
            alwaysShowAllBtns: true,
            sizePerPageList: sizePerPageOptions,
            onPageChange: (page, sizePerPage) => {
                const skp = (page - 1) * sizePerPage;
                const filters = `?filter[skip]=${skp}&filter[limit]=${sizePerPage}`;
                that.setState({
                    pageChange: page,
                    skip: skp,
                    limit: sizePerPage
                }, () => {
                    that.getGeneralContractList(filters);
                });
            },
            onSizePerPageChange: (sizePerPage, page) => {
                const skp = (page - 1) * sizePerPage;
                const filters = `?filter[skip]=${skp}&filter[limit]=${sizePerPage}`;
                that.setState({
                    pageChange: page,
                    skip: skp,
                    limit: sizePerPage
                }, () => {
                    that.getGeneralContractList(filters);
                });
            }
        });


        const roleKey = loginUserData.roleKey;
        const isAccess = (roleKey !== "" && rules[roleKey][Permission.MASTER_WRITE]) ? true : false;

        return (
            <div>  {!isAccess ? <AccessDenied /> :
                <div className="main-content">
                    <ConfirmBox
                        openModal={isShowConfirmBox}
                        confirmMsg="Are you sure to delete this general contractor?"
                        handleConfirmModal={this.handleConfirmModal}
                    />
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-flex align-items-center justify-content-between">
                                        <ol className="breadcrumb m-0">
                                            <Link to={`/#`}><li className="breadcrumb-item">Home</li></Link>
                                            &nbsp; / &nbsp;
                                            <Link to={`/generalContractorList`}><li className="breadcrumb-item">General Contractor List</li></Link>
                                        </ol>
                                    </div>
                                    <h4 className="mb-0">General Contractor</h4>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card card-block">
                                        <div className="card-body">
                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <Link to="/addGeneralContractor">
                                                            <span className="btn btn-success waves-effect waves-light" onClick={this.setLocalStorageItems}>
                                                                <i className="uil uil-plus"></i> Add New
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-inline float-md-end mb-3">
                                                        <div className="search-box ms-2">
                                                            {/* Search can be added later */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <BootstrapTable
                                                remote={{ pagination: true, sort: true }}
                                                keyField="id"
                                                data={generalContractorList}
                                                columns={columns}
                                                onTableChange={this.handleOnTableChange}
                                                pagination={pagination}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>

        )
    }
}

const mapStateToProps = (state) => ({
    loginUserData: state.loginUserData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GeneraContractorList);
